// Procura o primeiro elemento pai que permite deslocar o conteúdo verticalmente.
const getScrollContainer = (el) => {
    for (let node = (el && el.parentElement); node && node !== document.body; node = node.parentElement) {
        const overflowY = window.getComputedStyle(node).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && (node.scrollHeight > node.clientHeight)) return node;
    }
    return null;
};

// Calcula o espaço disponível acima e abaixo do elemento
const getSpaces = (el, anchorRect) => {
    const scrollContainer = getScrollContainer(el);
    if (scrollContainer) {
        const container = scrollContainer.getBoundingClientRect();
        return { above: anchorRect.top - container.top, below: container.bottom - anchorRect.bottom };
    }
    return { above: anchorRect.top, below: window.innerHeight - anchorRect.bottom };
};

export default {
    // Mostra o popover e decide se ele deve aparecer acima ou abaixo com base no espaço disponível
    openPopover() {
        this.isPopoverVisible = true;
        this.$nextTick(() => {
            const popoverElement = this.$el.querySelector('.note-popover, .transport-popover');
            if (!popoverElement) return;
            const anchorRect = this.$el.getBoundingClientRect();
            const popoverHeight = popoverElement.offsetHeight;
            const gap =10;
            const { above: spaceAbove, below: spaceBelow } = getSpaces(this.$el, anchorRect);

            const fitsBelow = (popoverHeight + gap) <= spaceBelow;
            const fitsAbove = (popoverHeight + gap) <= spaceAbove;

            if (fitsBelow) { this.isPopoverAbove = false; return; }
            if (fitsAbove) { this.isPopoverAbove = true; return; }
            // Não cabe em nenhum lado: preferir abaixo para evitar overflow no topo
            this.isPopoverAbove = false;
        });
    },

    closePopover() {
    this.isPopoverVisible = false;
    this.isPopoverAbove = false;
    }
};



// WEBPACK FOOTER //
// ./src/utils/hoverHelper.js